import { create } from "zustand";

interface ResizeGuideStoreType {
  lineDirection: "vertical" | "horizon";
  lineX: number;
  lineY: number;
  resizeGuideLineVisible: boolean;
  setResizeGuideLineVisible: (visible: boolean) => void;
  setLineX: (x: number) => void;
  setLineY: (y: number) => void;
}

const useResizeGuideStore = create<ResizeGuideStoreType>((set) => ({
  lineDirection: "horizon",
  lineX: 0,
  lineY: 0,
  resizeGuideLineVisible: false,

  setResizeGuideLineVisible: (visible) => {
    set({ resizeGuideLineVisible: visible });
  },
  setLineX: (x: number) => {
    set({
      lineDirection: "vertical",
      lineX: x,
    });
  },
  setLineY: (y: number) => {
    set({
      lineDirection: "horizon",
      lineY: y,
    });
  },
}));

export default useResizeGuideStore;
